import { render, staticRenderFns } from "./Roast.vue?vue&type=template&id=19ac8910&"
import script from "./Roast.vue?vue&type=script&lang=js&"
export * from "./Roast.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports